import { Modal, Switch, Button } from 'antd';
import { FC, useEffect, useState } from 'react';
import { Tag } from '../../../../../../lib/model/Tag';
import { SelectTags } from '../SelectTags';
import { SelectTagType } from './SelectTagType';
import { TagTypeWithColor } from './tag_type';
import { PeriodicTagsForm } from '../PeriodicTagsForm';
import { NewsTagForm } from '../NewsTagForm';
import { CodeTagForm } from '../CodeTagForm';
import { SelectTypeBooks } from '../SelectTypeBook';
import { TypeBooks } from '../../../model/TypeBooks';

import { Input, Space } from 'antd';
import { SearchableProvider } from '../../../../../../lib/components/SearchableDataTable/SearchableProvider';
import { default_query } from '../../../../../../lib/utils/consts';
import { ListBooks } from '../../../components/forms/ListBooks';
import { ContentDataTable } from '../../../../../store/content_assignment/components/ContentDataTable';
import { ContentInsertModal } from '../../../../../store/content_assignment/components/ContentModal';
import { BookEditionSelect } from '../../../../../../lib/features/book_edition/components/BookEditionSelect';
import { Content } from '../../../../../../lib/model/Content';
import { LooseBookForm } from '../LooseBookForm';
import { forEach } from 'lodash';
import { title } from 'process';
import { PlatformAllTagForm } from '../PlatformAllTagForm';
import { SelectTagsBooksSeries } from '../SelectTagsBooksSeries';
import { SelectTagsVidsSeries } from '../SelectTagsVidsSeries';
import { SelectTagsIaUser } from '../SelectTagsIaUser';
import { ForumSignatureTag } from '../ForumSignatureTag';
import { request } from '../../../../../../lib/utils/request';
import { Client } from '../../../../../../lib/model/Client';

interface IProps {
	visible: boolean;
	close: () => void;
	on_change: (tags: Tag[]) => void;
	tag_type: TagTypeWithColor;
	on_select_tag_type: (tag_type: TagTypeWithColor) => void;
	tags: Tag[];
	periodics?: any[];
	isBook: boolean;
	contents: Content[] | [];
	save: () => void;
	partner?: Client;
}

export const ContentSeriesModal: FC<IProps> = ({
	visible,
	close,
	on_change,
	tag_type,
	on_select_tag_type,
	tags,
	periodics,
	contents,
	save,
	partner,
}) => {
	const [isTypeSelect, setIsTypeSelect] = useState<String>();
	const [localTags, setLocalTags] = useState<Tag[]>(tags);

	useEffect(() => {
		if (visible) {
			setLocalTags(tags);
		}
	}, [visible, tags]);

	const handleSave = async () => {
		try {
			await save();
		} catch (err) {
			console.error('Erro ao salvar contrato:', err);
		}
	};

	const handleCancel = () => {
		close();
	};

	const abreSelectBooks = (tipo: string, valorSelecionado: string) => {
		setIsTypeSelect(valorSelecionado);
	};

	useEffect(() => {
		setIsTypeSelect('Selecione');
	}, []);

	const hasForumSignature = tags.some((item) => item.id.includes('forum-signature'));
	const disabledByForumSignature = hasForumSignature;
	return (
		<Modal
			{...{
				visible,
				closable: true,
				onCancel: handleCancel,
				centered: true,
				destroyOnClose: true,
				title: 'Seleção de Conteúdos do Contrato',
				width: 800,
				footer: [
					<Button key='cancel' onClick={handleCancel}>
						Cancelar
					</Button>,
					<Button key='save' type='primary' onClick={handleSave} disabled={localTags.length === 0}>
						Salvar
					</Button>,
				],
			}}
		>
			<>
				<ForumSignatureTag
					{...{
						selected_contents: tags,
						tag_type,
						on_change,
						close,
					}}
				/>
				<SelectTagType {...{ on_select_tag_type, disabled: disabledByForumSignature }} />

				{tag_type.value && (
					<>
						<h2 className='mt-2 mb-0'>
							{tag_type?.value === 'periodic' ? 'Tags de Revistas' : ''}
							{tag_type?.value === 'ia'
								? 'Insira o e-mail para ativar o módulo de IA para o usuário'
								: ''}
							{tag_type?.value === 'book' ? 'Selecione um item' : ''}
							{!['periodic', 'news', 'code', 'book', 'ia'].includes(tag_type?.value)
								? `Séries de ${tag_type.title}`
								: ''}
						</h2>
						{tag_type?.value === 'periodic' ? (
							<PeriodicTagsForm
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									disabled: disabledByForumSignature,
								}}
							/>
						) : (
							<></>
						)}

						{tag_type?.value === 'news' ? (
							<NewsTagForm
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									disabled: disabledByForumSignature,
								}}
							/>
						) : (
							<></>
						)}

						{tag_type?.value === 'code' ? (
							<CodeTagForm
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									disabled: disabledByForumSignature,
								}}
							/>
						) : (
							<></>
						)}

						{tag_type?.value === 'book' && isTypeSelect === 'Selecione' ? (
							<>
								<SelectTypeBooks
									{...{
										value: TypeBooks.SELECIONE,
										on_change: abreSelectBooks,
										disabled: disabledByForumSignature,
									}}
								/>
							</>
						) : (
							<></>
						)}
						{tag_type?.value === 'book' && isTypeSelect === 'Livro Avulso' ? (
							<>
								<SelectTypeBooks
									{...{
										value: TypeBooks.LIVRO_AVULSO,
										on_change: abreSelectBooks,
										disabled: disabledByForumSignature,
									}}
								/>
								<LooseBookForm
									{...{
										selected_contents: tags,
										tag_type,
										on_change,
										close,
										periodics,
										contents,
										disabled: disabledByForumSignature,
									}}
								/>
							</>
						) : (
							<></>
						)}
						{tag_type?.value === 'book' && isTypeSelect === 'Coleção' ? (
							<>
								<SelectTypeBooks
									{...{
										value: TypeBooks.COLECAO,
										on_change: abreSelectBooks,
										disabled: disabledByForumSignature,
									}}
								/>
								<SelectTagsBooksSeries
									{...{
										selected_contents: tags,
										tag_type,
										on_change,
										close,
										periodics,
										disabled: disabledByForumSignature,
									}}
								/>
							</>
						) : (
							<></>
						)}

						{/* {isBook ? (
						<SelectTags
							{...{
								selected_contents: tags,
								tag_type,
								on_change,
								close,
								periodics,
							}}
						/>
					) : (
						<></>
					)} */}
						{tag_type?.value === 'video' ? (
							<SelectTagsVidsSeries
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									periodics,
									disabled: disabledByForumSignature,
								}}
							/>
						) : (
							<></>
						)}
						{!['periodic', 'news', 'code', 'book', 'video', 'ia'].includes(tag_type?.value) ? (
							<SelectTags
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									periodics,
									disabled: disabledByForumSignature,
								}}
							/>
						) : (
							<></>
						)}
						{tag_type?.value === 'ia' ? (
							<SelectTagsIaUser
								{...{
									selected_contents: tags,
									tag_type,
									on_change,
									close,
									periodics,
								}}
							/>
						) : (
							<></>
						)}
					</>
				)}
			</>
		</Modal>
	);
};
